import { useLanguage } from "@/i18n/LanguageContext";
const cols = [
  {
    title: "Basic OEE Monitoring Tools",
    tone: "muted",
    items: [
      "Fast to start",
      "Good for machine visibility",
      "Good for downtime tracking",
      "Usually limited for material flow, QR, job execution, quality, CMMS and ERP/APS integration",
      "Good first step, but often not a full manufacturing execution platform",
    ],
  },
  {
    title: "Traditional Enterprise MES",
    tone: "muted",
    items: [
      "Very powerful",
      "Deep enterprise functionality",
      "Strong for large corporations",
      "Often requires long analysis, customization, infrastructure, consulting and budget",
      "Can be too heavy for small and mid-size manufacturers",
    ],
  },
  {
    title: "BEEDIGIT",
    tone: "primary",
    items: [
      "Plug & Play start with one line or bottleneck",
      "Full MES modules available step by step",
      "Industrial hardware preconfigured",
      "Industry templates ready from day one",
      "OEE, MES, Material Flow, QR, Quality, CMMS, Andon and Energy in one platform",
      "ERP / APS ready",
      "Affordable for small factories, scalable for enterprise holdings",
    ],
  },
];

export default function MarketPositioning() {
  const { t } = useLanguage();
  return (
    <section className="py-16 md:py-20 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mb-10">
          <p className="eyebrow mb-3">{t("Positioning")}</p>
          <h2 className="text-3xl md:text-4xl font-bold mb-3">{t("Fast like OEE monitoring. Powerful like MES. Easier to adopt than traditional projects.")}</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-4">
          {cols.map((c) => (
            <div
              key={c.title}
              className={
                c.tone === "primary"
                  ? "rounded-lg border-2 border-primary bg-card p-5 shadow-glow-primary"
                  : "rounded-lg border border-border bg-card/60 p-5"
              }
            >
              <p className={`text-xs uppercase font-semibold tracking-wider mb-3 ${c.tone === "primary" ? "text-primary" : "text-muted-foreground"}`}>
                {c.tone === "primary" ? "Recommended" : "Market option"}
              </p>
              <h3 className="font-semibold text-lg mb-3">{t(c.title)}</h3>
              <ul className="space-y-2">
                {c.items.map((it) => (
                  <li key={it} className="text-sm text-foreground/85 flex gap-2">
                    <span className={c.tone === "primary" ? "text-primary" : "text-muted-foreground"}>—</span>
                    <span>{t(it)}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="mt-8 text-foreground/90 max-w-3xl">
          {t("BEEDIGIT lets manufacturers start small, prove value fast, and scale without replacing the platform later.")}
        </p>
      </div>
    </section>
  );
}